export const CHANGE_FILTERS_STATE = 'CHANGE_FILTERS_STATE';

interface ChangeFiltersState {
	type: typeof CHANGE_FILTERS_STATE;
	isOpen: boolean;
};

export type FiltersState = {
	isOpen: boolean;
};

export type FiltersActionTypes = ChangeFiltersState;